import { resolveFirstScreenVariantIntl2Lw } from 'cohorts/intl_2lw/helpers/getFirstScreenVariant'
import { useEffect, useRef } from 'react'
import { useShallow } from 'zustand/shallow'
import { Cohort, GrowthbookKey } from 'root-constants'
import { useZustandStore } from 'zustandGlobalStore'

// abtest_web_127_first_screen (intl_2lw) can change the very first screen of
// its cohort's flow, so the flow (XState machine + route list) must not render
// until the variant is known.
// useGetGrowthbookVariantData writes an empty object while the GrowthBook
// instance is not initialized yet, so "not null" is not enough: wait for the
// entry of the experiment key (written only once GrowthBook has evaluated,
// even if the feature is missing or the SDK init timed out).
export const useIsFlowVariantResolved = (): boolean => {
  const { cohort, growthbookVariantData } = useZustandStore(
    useShallow((state) => ({
      cohort: state.lead?.cohort || state.initialCohort,
      growthbookVariantData: state.growthbookVariantData,
    })),
  )
  const snapshotCohortRef = useRef<string | null>(null)

  const hasFirstScreenVariant =
    !!growthbookVariantData?.[GrowthbookKey.ABTEST_WEB_127_FIRST_SCREEN]

  let isResolved = true
  if (cohort === Cohort.INTL_2LW) {
    isResolved = hasFirstScreenVariant
  }

  // Freeze the group once per cohort. Every synchronous consumer reads this
  // snapshot afterwards, so URL rewrites can no longer flip the flow shape.
  useEffect(() => {
    if (!cohort || !isResolved || snapshotCohortRef.current === cohort) return

    snapshotCohortRef.current = cohort

    if (cohort === Cohort.INTL_2LW) {
      useZustandStore.setState({
        firstScreenVariantIntl2Lw: resolveFirstScreenVariantIntl2Lw(),
      })
    }
  }, [cohort, isResolved])

  return isResolved
}
